import { render } from "./ThemeButton.vue?vue&type=template&id=5baca20d&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=5baca20d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baca20d"]])

export default __exports__